<template>
  <div v-if="showErrorMessage" class="text-center answer-audit">
    <div class="text-theme-black-850 text-large leading-22">
      <span>很遗憾，您提交答卷未过审</span>
    </div>
    <div class="text-small text-theme-black-450 mt-1">
      <span>未过审原因：</span>
      <span>{{ auditDescription }}</span>
    </div>
  </div>
</template>

<script>
import { AnswerStatus, busGetters } from 'dygc'

export default {
  name: 'AnswerAudit',
  computed: {
    status() {
      return this.overData?.status
    },
    showErrorMessage() {
      return this.status === AnswerStatus.QUALITY && this.auditDescription.length > 0
    },
    ...busGetters(['overData', 'auditDescription'])
  }
}
</script>
